<template>
  <div>
    <el-card class="mat12">
      <div class="main" v-if="dataDesc.hr && dataDesc.project.projectType != 4 && dataDesc.project.projectType != 2 && dataDesc.project.projectType != 6 && dataDesc.project.projectType != 8">
        <p class="title">项目编制</p>
        <div class="main-info">
          <el-col :span="6" class="name media_col">
            队长：
            <i class="num">{{dataDesc.hr.captainNum ? dataDesc.hr.captainNum : '0'}}人</i>
          </el-col>
          <el-col :span="6" class="name media_col">
            副队长：
            <i class="num">{{dataDesc.hr.vicecaptainNum?dataDesc.hr.vicecaptainNum:'0'}}人</i>
          </el-col>
          <el-col :span="6" class="name media_col">
            班长：
            <i class="num">{{dataDesc.hr.monitorNum? dataDesc.hr.monitorNum : '0'}}人</i>
          </el-col>
          <el-col :span="6" class="name media_col">
            队员：
            <i class="num">{{dataDesc.hr.staffNum? dataDesc.hr.staffNum : '0'}}人</i>
          </el-col>
        </div>
        <p class="title">人员标准</p>
        <div class="main-info">
          <el-col :span="6" class="name media_col">
            年龄范围：
            <i class="num">{{dataDesc.hr.minimumAge}}~{{dataDesc.hr.maxmumAge}}岁</i>
          </el-col>
          <el-col :span="6" class="name media_col">
            身高范围：
            <i class="num">{{dataDesc.hr.minimumHeight}}cm~{{dataDesc.hr.maxmumHeight}}cm</i>
          </el-col>
          <el-col :span="12" class="name media_col">
            特殊要求：
            <i class="num">{{dataDesc.hr.remark ?dataDesc.hr.remark:'无'}}</i>
          </el-col>
        </div>
        <p class="title">人员状态</p>
        <div class="main-info">
          <span class="name">
            当前已安排人数：
            <i class="num">{{dataDesc.hr.count ? dataDesc.hr.count:0}}人</i>
            <router-link
              v-if="path"
              :to="{path:path,query:{projectId:projectId,type:dataDesc.project.projectType}}"
              tag="span"
              class="desc_color"
            >查看详情&gt;&gt;&gt;</router-link>
            <span v-if="!num && path" class="warning">当前人数不匹配!</span>
          </span>
        </div>
      </div>
       <div class="main" v-else>
          <div class="main-info" style="margin-top:10px">
          <el-col :span="6" class="name">
            投入人数：
            <i class="num">{{dataDesc.proCH.invest?dataDesc.proCH.invest:0}}人</i>
          </el-col>
          <el-col :span="6" class="name">
            投入时长：
            <i class="num">{{dataDesc.proCH.duration?dataDesc.proCH.duration:0}}时</i>
          </el-col>
          <el-col :span="6" class="name">
            备注：
            <i class="num">{{dataDesc.proCH.remark ?dataDesc.proCH.remark:'无'}}</i>
          </el-col>
           </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "CardProjectSetting",
  props: {
    dataDesc: {
      type: Object,
      default: {}
    },
    projectId: {
      type:  Number,
      default: null
    },
    path: {
      type: String,
      default: ""
    }
  },
  computed: {
    num() {
      let hrNum =
        Number(this.dataDesc.hr.captainNum) +
        Number(this.dataDesc.hr.vicecaptainNum) +
        Number(this.dataDesc.hr.monitorNum) +
        Number(this.dataDesc.hr.staffNum);
      let hrCount = this.dataDesc.hr.count;
      return hrNum == hrCount;
    }
  }
};
</script>

<style lang="scss" scoped>
$color: #409eff;
$warning: #e6a23c;
.title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-bottom: 20px;
}
.main-info {
  // margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  i {
    font-style: normal;
  }
  .name {
    font-weight: bold;
    // margin-right: 25px;
    margin-bottom: 20px;
  }
  .num {
    font-weight: 400;
  }
  .desc_color {
    margin-left: 20px;
    color: $color;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
  }
  .warning {
    color: $warning;
    margin-left: 10px;
  }
}
</style>
